import { getUrl, Post } from '.'

export const SearchStaff = async body => {
  return Post(getUrl('cnps.sur.get-list-by-user'), body)
}

export const SearchUser = async body => {
  return Post(getUrl('cnps.sur.staff-get-list'), body)
}

export const GetUserByType = async typeSales => {
  return Post(getUrl('cnps.sur.get-users-by-type-sale'), { typeSales: [typeSales] })
}

export const SearchStaffInferior = async body => {
  return Post(getUrl('cnps.staff.get-type-sale-or-user-under'), body)
}
